// extracted by mini-css-extract-plugin
export var alignCenter = "_b1-d";
export var bannerShown = "_b1-6";
export var buttonContent = "_b1-0";
export var cardList = "_b1-1";
export var centerContent = "_b1-2";
export var chevron = "_b1-3";
export var closePanelButton = "_b1-k";
export var conversationContextContainer = "_b1-l";
export var conversationDetailContainer = "_b1-4";
export var detailWrapper = "_b1-7";
export var dropdownButton = "_b1-e";
export var dropdownTitle = "_b1-9";
export var fullHeight = "_b1-5";
export var hidden = "_b1-a";
export var icon = "_b1-b";
export var mergeSuggestionWrapper = "_b1-m";
export var panel = "_b1-i";
export var portalButtonsWrapper = "_b1-c";
export var right = "_b1-j";
export var tableSummaryContainer = "_b1-8";
export var tableSummaryHeader = "_b1-g";
export var threeDotsButton = "_b1-f";
export var wide = "_b1-h";